// extracted by mini-css-extract-plugin
module.exports = {"text":"_103a151b99--text--Y_6zi"};